// extracted by mini-css-extract-plugin
module.exports = {"Container":"Reasons_Container__1jV3d","Intro":"Reasons_Intro__dHlZj","ReasonsContainer":"Reasons_ReasonsContainer__2RXFK"};